import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';

import { AuthService } from '@app/modules/admin/auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminSocialConnectFeatureResolver implements Resolve<any> {
  constructor(private router: Router, private authService: AuthService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    if (this.authService.isSocialConnectFeatureEnabled) return of(true);
    else {
      this.router.navigate(['/dashboard']);
      return of(false);
    }
  }
}
